<div atlas-banner>
  <div atlas-banner-content>
    <p class="m-0 mat-body">
      The notification function is currently being turned off.
    </p>
  </div>
  <div atlas-banner-actions>
    <button atlas-button
      color="accent"
      class="text-uppercase me-2"
      (click)="getDismissAction()">
      Dismiss
    </button>
    <button atlas-button
      color="accent"
      class="text-uppercase">
      Turn on notification
    </button>
  </div>
</div>